import { useState } from "react";
import { useApp } from "@/lib/AppContext";
import { t } from "@/lib/translations";

export default function PhoneInput({ onSubmit, loading, error, checkMsg, onClearMsg }) {
  const [phone, setPhone] = useState("");
  const { lang } = useApp();
  const tr = t[lang];

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(phone.trim());
  };

  const features = [
    { icon: "🎁", label: lang === "ar" ? "عروض حصرية" : "Exclusive Offers" },
    { icon: "⚡", label: lang === "ar" ? "فوري وسريع" : "Fast & Instant" },
    { icon: "🔒", label: lang === "ar" ? "آمن وموثوق" : "Secure & Safe" },
  ];

  return (
    <div className="flex flex-col items-center gap-8">
      {/* Hero Section */}
      <div className="text-center space-y-4">
        <div className="w-24 h-24 mx-auto bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center text-5xl shadow-lg">
          🎡
        </div>
        <h2 className="text-3xl font-black text-primary leading-tight">
          {tr.welcomeTitle}
        </h2>
        <p className="text-muted-foreground max-w-sm mx-auto leading-relaxed">
          {tr.welcomeSubtitle}
        </p>
      </div>

      {/* Features */}
      <div className="grid grid-cols-3 gap-3 w-full max-w-sm">
        {features.map((f) => (
          <div key={f.label} className="bg-card rounded-xl p-3 text-center shadow-sm border border-border">
            <div className="text-2xl mb-1">{f.icon}</div>
            <p className="text-xs font-semibold text-foreground">{f.label}</p>
          </div>
        ))}
      </div>

      {/* Phone Form */}
      <div className="w-full max-w-sm">
        {checkMsg ? (
          <div className="bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800 rounded-2xl p-6 text-center">
            <div className="text-4xl mb-3">⏰</div>
            <h3 className="font-bold text-amber-800 dark:text-amber-300 mb-2">
              {lang === "ar" ? "عذراً!" : "Sorry!"}
            </h3>
            <p className="text-amber-700 dark:text-amber-400 text-sm leading-relaxed">{checkMsg}</p>
            <button
              onClick={onClearMsg}
              className="mt-4 text-xs text-amber-600 dark:text-amber-400 underline"
            >
              {lang === "ar" ? "إدخال رقم آخر" : "Try another number"}
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="bg-card rounded-2xl p-6 shadow-lg border border-border space-y-4">
            <div>
              <label className="block text-sm font-bold text-foreground mb-2">
                {tr.phoneLabel}
              </label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
                placeholder={tr.phonePlaceholder}
                maxLength={10}
                className="w-full px-4 py-3.5 text-center text-xl font-bold tracking-widest border-2 border-border rounded-xl focus:outline-none focus:border-primary transition-colors bg-secondary/30"
                dir="ltr"
              />
              {error && (
                <p className="mt-2 text-sm text-destructive text-center font-medium">{error}</p>
              )}
              <p className="mt-1 text-xs text-muted-foreground text-center">
                {lang === "ar" ? "مثال: 0512345678" : "Example: 0512345678"}
              </p>
            </div>

            <button
              type="submit"
              disabled={loading || phone.length < 10}
              className="w-full py-4 bg-gradient-to-r from-primary to-accent text-white text-lg font-black rounded-xl shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  {tr.checkingEligibility}
                </span>
              ) : `🚀 ${tr.spinBtn}`}
            </button>
          </form>
        )}
      </div>

      {/* Terms */}
      <p className="text-xs text-muted-foreground text-center max-w-xs">
        {lang === "ar"
          ? "بالمشاركة، أنت توافق على شروط الاستخدام. كل رقم جوال مؤهل للمشاركة مرة واحدة خلال فترة الحملة."
          : "By participating, you agree to the terms of use. Each phone number is eligible to participate once per campaign period."}
      </p>
    </div>
  );
}